"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StarTextureGenerator = void 0;
const PIXI = __importStar(require("pixi.js"));
const app_1 = require("@kennethgomez/app");
class StarTextureGenerator {
    static _base;
    static _buildStarBaseTexture() {
        const g = new PIXI.Graphics();
        g.beginFill(0xFFFFFF);
        g.drawCircle(0, 0, 0.75);
        g.endFill();
        return app_1.App.instance.canvas.app.renderer.generateTexture(g);
    }
    static get base() {
        // eslint-disable-next-line no-return-assign
        return this._base ?? (this._base = this._buildStarBaseTexture());
    }
}
exports.StarTextureGenerator = StarTextureGenerator;
